import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import BloodDonationDashboard from "./BloodDonationDashboard";
import BloodDonationCenter from "./BloodDonationCenter";
import { LinkDonorAccount } from './linkAccount/LinkDonorAccount';
import { useState, useEffect } from 'react';
import { fetchTranslationData } from "../../services/translation/translation";
import { ServiceTranslation } from "../../utils/constants";
import { Loader } from '../../common/Loader';

const BloodDonation = () => {
  const [linkSuccessful, setLinkSuccessful] = useState(false);
  const [email,setEmail] = useState(null);
  const [translationMap, setTranslationMap] = useState(null);
  const [requestStep, setRequestStep] = useState(-1);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    fetchTranslationData(ServiceTranslation.BloodDonation).then((result) => {
      setTranslationMap(result);
    });
    setLoading(false);
  },[]);

  if(loading)
  {
    return(
      <Loader/>
    )
  }
   
  return (
      <Router>
      <Routes>
        <Route path="/detail/:webStructurePk/:templateId" element={<BloodDonationCenter/>} />
        <Route path="/" element={<BloodDonationDashboard linkSuccessful={linkSuccessful} email={email} setLinkSuccessful={setLinkSuccessful} setEmail={setEmail} requestStep={requestStep} setRequestStep={setRequestStep} translationMap={translationMap}/>}/>
        <Route path="/link-account" element={<LinkDonorAccount linkSuccessful={linkSuccessful} setLinkSuccessful={setLinkSuccessful} email={email} requestStep={requestStep} setRequestStep={setRequestStep} translationMap={translationMap}/>}/>
      </Routes>
    </Router>
  );
};

export default BloodDonation;
